(() => {
  'use strict';
  const config = document.querySelector('[data-sy-advisor-application-config]');
  if (!config) return;
  const formId = '161563';
  const variantId = '59935085396254';
  const storageKey = 'smartyield.advisor.application.v2';
  const validReference = value => /^SYAPP-[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/.test(value || '');
  const applicationUrl = config.dataset.applicationUrl;
  const lifetime = 24 * 60 * 60 * 1000;

  function prepareApplication(form) {
    if (form?.getAttribute('data-id') !== formId) return;
    const field = form.querySelector('input[name="hidden-2"]');
    if (field && !validReference(field.value)) field.value = 'SYAPP-' + crypto.randomUUID();
  }

  function readApplication() {
    try {
      const value = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (value?.formId !== formId || !validReference(value.reference) ||
          !Number.isFinite(value.submittedAt) || value.submittedAt > Date.now() ||
          Date.now() - value.submittedAt > lifetime) return null;
      return value;
    } catch { return null; }
  }

  function updatePurchaseForms() {
    for (const form of document.querySelectorAll('form[action*="/cart/add"]')) {
      if (form.querySelector('[name="id"]')?.value !== variantId) continue;
      const application = readApplication();
      let property = form.querySelector('input[name="properties[_smartyield_application]"]');
      if (!property) {
        property = document.createElement('input');
        property.type = 'hidden';
        property.name = 'properties[_smartyield_application]';
        form.append(property);
      }
      property.value = application?.reference || '';
      property.disabled = !application;
      let message = form.querySelector('[data-sy-application-message]');
      if (!message) {
        message = document.createElement('p');
        message.dataset.syApplicationMessage = '';
        message.setAttribute('role', 'status');
        form.prepend(message);
      }
      const text = application
        ? 'Your advisor application is connected to this registration. Billing details can belong to someone else.'
        : 'Please submit your advisor application before completing registration.';
      if (message.firstChild?.textContent !== text) {
        message.replaceChildren(document.createTextNode(text));
        if (!application) {
          const link = document.createElement('a');
          link.href = applicationUrl;
          link.textContent = ' Open advisor application';
          message.append(link);
        }
      }
      for (const button of form.querySelectorAll('button[type="submit"]')) {
        if (!application && !button.disabled) { button.dataset.syBlocked = 'true'; button.disabled = true; }
        if (application && button.dataset.syBlocked === 'true') { delete button.dataset.syBlocked; button.disabled = false; }
      }
      for (const accelerated of form.querySelectorAll('.shopify-payment-button, shopify-accelerated-checkout')) {
        if (!application && !accelerated.hidden) { accelerated.dataset.syBlocked = 'true'; accelerated.hidden = true; }
        if (application && accelerated.dataset.syBlocked === 'true') { delete accelerated.dataset.syBlocked; accelerated.hidden = false; }
      }
    }
  }

  document.addEventListener('globo.formbuilder.form.loaded', event => prepareApplication(event.detail?.form));
  document.addEventListener('globo.formbuilder.form.beforeSubmit', event => prepareApplication(event.detail?.form));
  document.addEventListener('globo.formbuilder.form.reset', event => {
    if (event.detail?.formId !== formId) return;
    const field = event.detail.form.querySelector('input[name="hidden-2"]');
    if (field) field.value = '';
    prepareApplication(event.detail.form);
  });
  document.addEventListener('globo.formbuilder.form.submitted', event => {
    const {form, formId: submittedFormId, response} = event.detail || {};
    if (String(submittedFormId) !== formId || !Array.isArray(response) || !response.some(value => String(value?.success) === 'true')) return;
    const reference = form.querySelector('input[name="hidden-2"]')?.value;
    if (!validReference(reference)) return;
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({formId, reference, submittedAt: Date.now()}));
    } catch {
      // Checkout remains unavailable rather than attaching this application to an unrelated account.
    }
    updatePurchaseForms();
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches?.('form[action*="/cart/add"]') || form.querySelector('[name="id"]')?.value !== variantId) return;
    updatePurchaseForms();
    if (!readApplication()) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.querySelectorAll('form[data-id="161563"]').forEach(prepareApplication);
  updatePurchaseForms();
  let scheduled = false;
  new MutationObserver(records => {
    if (scheduled || !records.some(record => record.addedNodes.length && record.target.nodeType === 1 && !record.target.closest('[data-sy-application-message]'))) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; updatePurchaseForms(); });
  }).observe(document.body, {childList: true, subtree: true});
})();
